module.exports = __webpack_public_path__ + "static/media/icon-read.d559576a.svg";